// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"prizes__wrapper__JfD8I","title":"prizes__title__3_5We","buttonAdd":"prizes__buttonAdd__1Taiu"};